import AccountStatementReport from './AccountStatementReport';

export default AccountStatementReport;
